import { createAction, createReducer } from '@reduxjs/toolkit';
import { SharedFoldersFilePayload, SharedFoldersState } from './sharedFoldersTypes';

export const setFolders = createAction<SharedFoldersState>('SET_FOLDERS');
export const setFiles = createAction<SharedFoldersFilePayload>('SET_FILES');
export const setLoadingFiles = createAction<boolean>('SET_LOADING_FILES');

const initialState: SharedFoldersState = {
  skip: 0,
  totalSharedFolders: 0,
  workspaceSharedFolders: [],
  loadingFiles: false,
};

export const sharedFoldersReducer = createReducer(initialState, builder => {
  builder.addCase(setFolders, (state, action) => {
    state.workspaceSharedFolders = action.payload.workspaceSharedFolders;
    state.totalSharedFolders = action.payload.totalSharedFolders;
    state.skip = action.payload.skip;
  });
  builder.addCase(setFiles, (state, action) => {
    const folderIx = state.workspaceSharedFolders.findIndex(sf => sf.id === action.payload.folderId);
    if (folderIx > -1) {
      state.workspaceSharedFolders[folderIx].files = action.payload.files;
    }
  });
  builder.addCase(setLoadingFiles, (state, action) => {
    state.loadingFiles = action.payload;
  });
});
